export const Header = {
  title: {
    h1: 'Investasi Reksadana Online',
    other: 'Terbaik Di BukaReksa',
  },
  subtitle: 'Buka rekening reksadana secara online bisa cepat dan mudah.',
};

export const Benefits = {
  title: 'Keuntungan berinvestasi di BukaReksa',
  items: [
    {
      image: 'icons/img_small_investment_bukareksa.png',
      title: 'Minimum dana investasi sangat terjangkau',
      subtitle:
        'Dana minimum untuk investasi dimulai dari Rp10.000 saja. Sangat terjangkau dibandingkan investasi minimum reksa dana pada umumnya.',
    },
    {
      image: 'icons/img_small_investment_option.png',
      title: 'Pilih produk sesuai kebutuhan',
      subtitle:
        'Banyak pilihan produk yang dikelola Manajer Investasi ternama. Tidak ada biaya tambahan untuk banyak produk saat bertransaksi.',
    },
    {
      image: 'icons/img_small_money_success.png',
      title: 'Transaksi reksa dana praktis dan aman',
      subtitle:
        'Daftar, beli, jual dan pantau reksa dana kapan saja.  Tidak perlu nunggu uang banya untuk mulai investasi.',
    },
    {
      image: 'icons/img_small_investment.png',
      title: 'Proses transaksi Reksa Dana sangat sederhana',
      subtitle:
        'Kamu dapat melakukan transaksi Reksa Dana cukup dengan memilih produk yang diinginkan kemudian masukkan data yang dibutuhkan.',
    },
    {
      image: 'icons/img_small_money_dompet.png',
      title: 'Investasi dapat dicairkan kapan pun kamu mau',
      subtitle:
        'Reksa dana memberikan keuntungan lebih tinggi daripada tabungan dan deposito di bank. Dana investasi dapat dicairkan kapan pun dengan cepat.',
    },
  ],
};

export const ProductList = {
  title: 'Pilihan produk BukaReksa',
  subtitle: 'Berdasarkan 30 hari terakhir, merupakan performa historikal, bukan prediksi.',
};

export const VideoList = {
  title: 'Cara seru jadi kaya raya',
  subtitle: 'Tonton cara berinvestasi dengan aman dan mudah di BukaReksa.',
};

export const ArticleList = {
  title: 'Bacaan seputar investasi',
  otherArticle: {
    text: 'Lihat artikel lainnya',
    url: `${process.env.BUKAREVIEW_HOST}/t/bukareksa`,
  },
};

export const TestimonyList = {
  title: 'Kata mereka tentang BukaReksa',
};

export const Footer = {
  aperd: {
    title: 'APERD',
    logoUrls: [
      { alt: 'bib', src: 'bib-logo.png' },
      { alt: 'tanamduit', src: 'tanamduit_logo.png' },
      { alt: 'bareksa', src: 'bareksalogo-bareksa-green-black@2x.png' },
    ],
  },
  ojk: {
    title: 'Diawasi oleh',
    logoUrl: { alt: 'ojk', src: 'logo-ojk-transparent.png' },
  },
  partner: {
    title: 'Partner',
    logoUrls: [{ alt: 'mandiri', src: 'mandiri-logo.png' }],
  },
};
